import ApiClient from '@/services/apiClient';
import Input from '@/models/input';

export default class AlarmInput {
    mode;
    input;
    external_alarm_id;

    constructor(mode = 0, input = new Input(1)) {
        this.mode = mode;
        this.input = input;
        this.external_alarm_id = "";
    }

    static constructFromObject(data, obj) {
        obj = obj || new AlarmInput();
        if (data) {
            if('input' in data) {
                obj.mode = 1;
                obj.input = Input.constructFromObject(data['input']);
            }
            if('external_alarm_id' in data) {
                obj.mode = 2;
                obj.external_alarm_id = data['external_alarm_id'] === ""? "" : ApiClient.convertToType(data['external_alarm_id'], 'Integer');
            }
            if('mode' in data) {
                obj.mode = ApiClient.convertToType(data['mode'], 'Integer');
            }
        }
        return obj;
    }

    toJSON() {
        if(this.mode == 1) {
            return {
                input: this.input,
            }
        } else {
            return {
                external_alarm_id: this.external_alarm_id,
            }
        }
    }
}
